/** 设计器界面中文原文 → 英文。未进 workbench 词条时由 fixedUi 回退到这里。 */
export const DESIGNER_UI_EN = {
  // 顶栏 / 保存 / 退出
  "未命名模板": "Untitled template",
  "返回工作台": "Back to workbench",
  "返回商品详情": "Back to product detail",
  "合成图": "Composite",
  "编辑合成图": "Edit composite",
  "保存模板": "Save template",
  "保存中…": "Saving…",
  "保存并重新合成": "Save & recompose",
  "合成中…": "Compositing…",
  "保存并退出": "Save & exit",
  "不保存，直接退出": "Discard & exit",
  "未保存的更改": "Unsaved changes",
  "当前模板有未保存的修改，离开后将丢失这些更改。请选择如何处理。":
    "This template has unsaved changes that will be lost if you leave. Choose how to continue.",
  "当前合成图有未保存的修改，离开后将丢失这些更改。请选择如何处理。":
    "This composite has unsaved changes that will be lost if you leave. Choose how to continue.",
  "请先填写模板名称后再保存": "Enter a template name before saving",
  "模板已被其他会话修改": "This template was modified in another session",
  "是否强制覆盖服务器版本并退出？": "Overwrite the server version and exit?",
  "是否强制覆盖服务器版本？此操作不可撤销。":
    "Overwrite the server version? This cannot be undone.",
  "已取消保存，请刷新模板后重试": "Save cancelled. Refresh the template and try again.",
  "强制覆盖失败，请重试": "Force overwrite failed. Please try again.",
  "保存失败，请重试": "Save failed. Please try again.",
  "编辑器未就绪": "Editor is not ready",
  "模板已创建并保存": "Template created and saved",
  "模板保存成功": "Template saved",
  "已强制覆盖保存": "Saved with force overwrite",
  "请为每张主图选择颜色": "Select a color for each main image",
  "新建设计": "New design",
  "模板 {0}": "Template {0}",

  // 菜单
  "主菜单": "Main menu",
  "文件": "File",
  "编辑": "Edit",
  "图层": "Layers",
  "图像": "Image",
  "打开文件": "Open file",
  "导入IPE": "Import IPE",
  "导出IPE": "Export IPE",
  "导出png": "Export PNG",
  "清空画布": "Clear canvas",
  "上传中…": "Uploading…",
  "上传功能未就绪，请刷新页面重试": "Upload is not ready. Refresh and try again.",
  "剪切": "Cut",
  "粘贴": "Paste",
  "复制图层": "Duplicate layer",
  "全选": "Select all",
  "取消选区": "Deselect",
  "自由变换": "Free transform",
  "组合": "Group",
  "解组": "Ungroup",
  "上移一层": "Bring forward",
  "下移一层": "Send backward",
  "置于顶层": "Bring to front",
  "置于底层": "Send to back",
  "左对齐": "Align left",
  "水平居中": "Align center horizontally",
  "右对齐": "Align right",
  "顶对齐": "Align top",
  "垂直居中": "Align center vertically",
  "底对齐": "Align bottom",
  "水平垂直居中": "Center",
  "裁剪为 1:1": "Crop to 1:1",
  "清除裁剪": "Clear crop",
  "水平翻转": "Flip horizontal",
  "垂直翻转": "Flip vertical",
  "选区蒙版置顶（添加）": "Selection mask on top (add)",
  "选区蒙版置底（减去）": "Selection mask at bottom (subtract)",
  "矩形蒙版": "Rectangle mask",
  "剪贴蒙版（下层）": "Clipping mask (below)",
  "清除蒙版": "Clear mask",

  // 工具条 / 工具名
  "工具": "Tools",
  "移动": "Move",
  "抓手": "Hand",
  "矩形选框": "Rectangular marquee",
  "圆形选框": "Elliptical marquee",
  "套索工具": "Lasso",
  "多边形套索工具": "Polygonal lasso",
  "魔棒": "Magic wand",
  "吸管": "Eyedropper",
  "钢笔": "Pen",
  "形状": "Shape",
  "矩形": "Rectangle",
  "椭圆": "Ellipse",
  "三角形": "Triangle",
  "多边形": "Polygon",
  "直线": "Line",
  "文字": "Type",
  "画笔": "Brush",
  "橡皮擦": "Eraser",
  "背景橡皮擦": "Background eraser",
  "魔术橡皮擦": "Magic eraser",
  "油漆桶": "Paint bucket",
  "蒙版笔刷": "Mask brush",
  "裁剪": "Crop",
  "当前工具正在开发中": "This tool is under development",
  "自由变换中，请先按 Esc 或 Ctrl+T 退出":
    "Free transform is active. Press Esc or Ctrl+T to exit first",
  " · 右键更多": " · right-click for more",
  "展开{0}工具": "Expand {0} tools",
  "{0}工具": "{0} tools",

  // 工具选项
  "选区模式": "Selection mode",
  "新选区": "New selection",
  "添加到选区": "Add to selection",
  "从选区减去": "Subtract from selection",
  "与选区交叉": "Intersect with selection",
  "（无选区时等同新建）": " (creates new if empty)",
  "羽化": "Feather",
  "消除锯齿": "Anti-alias",
  "容差": "Tolerance",
  "取样大小": "Sample size",
  "取样点": "Point sample",
  "3×3 平均": "3×3 average",
  "橡皮擦大小": "Eraser size",
  "背景橡皮擦大小": "Background eraser size",
  "大小": "Size",
  "硬度": "Hardness",
  "模式": "Mode",
  "擦除（隐藏）": "Erase (hide)",
  "涂抹（显示）": "Paint (reveal)",
  "确认裁剪": "Apply crop",
  "取消": "Cancel",
  "选择带参数的工具后，在此调整选项": "Select a tool with options to adjust them here",

  // 顶栏控件
  "缩小": "Zoom out",
  "适应": "Fit",
  "适应画布": "Fit canvas",
  "放大": "Zoom in",
  "标尺": "Ruler",
  "标尺开关": "Toggle ruler",
  "拖拽": "Pan",
  "拖动画布（或按住空格）": "Pan canvas (or hold Space)",
  "页面比例": "Page ratio",
  "修改画布比例": "Change canvas ratio",
  "撤销 Ctrl+Z": "Undo Ctrl+Z",
  "重做 Ctrl+Shift+Z": "Redo Ctrl+Shift+Z",

  // 左右栏 Tab / 面板
  "设计器左侧菜单": "Designer left menu",
  "印花区域": "Print area",
  "模板": "Templates",
  "字体": "Fonts",
  "素材": "Materials",
  "我的": "Mine",
  "图层面板": "Layers panel",
  "蒙版": "Mask",
  "商品主图": "Main images",
  "细节图": "Detail images",
  "画布": "Canvas",
  "文档 / 画布": "Document / canvas",
  "面板加载中…": "Loading panel…",
  "画布初始化中…": "Initializing canvas…",

  // 印花面板（首批）
  "添加印花区域": "Add print area",
  "基础设置": "Basics",
  "名称": "Name",
  "区域比例": "Area ratio",
  "贴合设置": "Fit settings",
  "印花填充模式": "Print fill mode",
  "对齐方式": "Alignment",
  "旋转": "Rotate",
  "效果": "Effects",
  "应用到全部": "Apply to all",
  "不透明度": "Opacity",
  "图片亮度": "Image brightness",
  "褶皱贴合": "Wrinkle fit",
  "弱": "Weak",
  "中等": "Medium",
  "强": "Strong",
  "阴影": "Shadow",
  "扩散": "Spread",
  "横向偏移": "Offset X",
  "竖向偏移": "Offset Y",
  "删除此印花区域": "Delete this print area",
  "描边": "Stroke",
  "颜色": "Color",
  "无": "None",
  "开启": "On",
  "描边大小": "Stroke size",
  "参考印花": "Reference print",
  "素材推荐": "Material picks",
  "AI 灵感": "AI ideas",
  "本地上传": "Upload locally",
  "图片空间": "Image library",
  "删除参考印花": "Remove reference print",

  // 历史标签
  "文本框": "Text box",
  "图片": "Image",
  "圆形": "Circle",
  "路径": "Path",
  "元素": "Element",
  "添加{0}": "Add {0}",
  "编辑文字": "Edit text",
  "缩放": "Scale",
  "倾斜": "Skew",
  "翻转": "Flip",
  "变换": "Transform",

  // 加载 / 画布区
  "图片上传中…": "Uploading image…",
  "模板加载中…": "Loading template…",
  "切换页面中…": "Switching page…",
  "画布加载中…": "Loading canvas…",
  "释放鼠标以上传图片": "Release to upload image",
  "过大自动压缩": "Large files are compressed automatically",
  "加载中…": "Loading…",
  "回到顶部": "Back to top",
  "拖拽调整左侧面板宽度，双击折叠": "Drag to resize the left panel; double-click to collapse",
  "拖拽调整右侧面板宽度，双击折叠": "Drag to resize the right panel; double-click to collapse",
  "拖拽调整宽度，双击折叠/展开": "Drag to resize; double-click to collapse/expand",

  // 颜色 / 工具选项补充
  "默认颜色": "Default colors",
  "默认颜色 (D)": "Default colors (D)",
  "交换前景背景色": "Swap foreground/background",
  "交换前景/背景色 (X)": "Swap foreground/background (X)",
  "前景色（Alt+Delete 填充）": "Foreground (Alt+Delete to fill)",
  "背景色（Ctrl+Delete 填充）": "Background (Ctrl+Delete to fill)",
  "添加到选区（无选区时等同新建）": "Add to selection (creates new if empty)",
  "Shift 临时添加 · Alt 临时减去": "Shift to add · Alt to subtract",
  "单击放置锚点并连线；点起点或 Enter 闭合并生成选区；可用左侧模式新建/添加/减去":
    "Click to place anchors; click the start point or press Enter to close and create a selection. Use modes on the left to new/add/subtract.",
  "拖动裁剪框，Enter 确认 / Esc 取消": "Drag the crop box; Enter to apply / Esc to cancel",
  "点击画布取样到前景色；按住 Alt 连续取色":
    "Click the canvas to sample the foreground; hold Alt to sample continuously",

  // 印花 / 参考印花
  "印花区域列表": "Print area list",
  "宽度": "Width",
  "高度": "Height",
  "褶皱强度": "Wrinkle strength",
  "手动调整": "Manual",
  "适应印花区域": "Fit print area",
  "充满印花区域": "Fill print area",
  "拉伸至印花区域": "Stretch to print area",
  "居中对齐": "Center",
  "向上对齐": "Align top",
  "向下对齐": "Align bottom",
  "向左对齐": "Align left",
  "向右对齐": "Align right",
  "当前成品图上没有印花区域，可先在模板里配置印花位。":
    "No print areas on this product image. Configure them in the template first.",
  "暂无印花区域，点击上方按钮在画布上添加。":
    "No print areas yet. Click the button above to add one on the canvas.",
  "从素材推荐、AI 灵感、本地上传或图片空间选择参考印花，将应用到模板内所有印花区域。":
    "Pick a reference print from materials, AI ideas, local upload, or the image library. It applies to all print areas in the template.",
  "{0}色块": "{0} swatch",
  "{0}色值": "{0} value",

  // 图层面板
  "文本": "Text",
  "图层名称": "Layer name",
  "套图贴合位": "Print fit slot",
  "贴合": "Fit",
  "重命名图层": "Rename layer",
  "请先用选区工具在图层上框选区域": "Use a selection tool to select an area on the layer first",
  "背景 {0}": "Background {0}",
  "新建背景图层": "New background layer",
  "原图层不变，复制选区为蒙版图层并置顶":
    "Keep the original layer; copy the selection as a mask layer on top",
  "原图层不变，复制选区为蒙版图层并置底":
    "Keep the original layer; copy the selection as a mask layer at the bottom",
  "添加（置顶）": "Add (bring to front)",
  "减去（置底）": "Subtract (send to back)",
  "选区蒙版：原图层不变，复制选区并置顶/置底":
    "Selection mask: keep the original layer; copy the selection to top/bottom",
  "新建白色背景图层": "New white background layer",
  "新建": "New",
  "组合选中图层": "Group selected layers",
  "新建空分组（文件夹）": "New empty group (folder)",
  "分组": "Group folder",
  "删除图层": "Delete layer",
  "至少保留一个图层": "Keep at least one layer",
  "调整透明度": "Adjust opacity",
  "剪贴蒙版失败：内容层须在蒙版层之上":
    "Clipping mask failed: the content layer must be above the mask layer",
  "图层可见性": "Layer visibility",
  "展开组合": "Expand group",
  "折叠组合": "Collapse group",
  "隐藏图层": "Hide layer",
  "显示图层": "Show layer",
  "锁定": "Lock",
  "解锁": "Unlock",
  "暂无图层": "No layers",
  "拖拽排序 · 拖入分组收纳图层 · 点击箭头展开/折叠 · 双击重命名":
    "Drag to reorder · Drop into a group · Click arrows to expand/collapse · Double-click to rename",

  // 选区 / 填充历史与 hint
  "添加选区": "Add selection",
  "减去选区": "Subtract selection",
  "交叉选区": "Intersect selection",
  "钢笔选区": "Pen selection",
  "创建选区": "Create selection",
  "移动选区": "Move selection",
  "变换选区": "Transform selection",
  "油漆桶填充": "Paint bucket fill",
  "至少需要 3 个锚点才能生成选区": "At least 3 anchors are required to create a selection",
  "路径无效，请继续添加锚点": "Invalid path. Keep adding anchors",
  "请先创建选区": "Create a selection first",
  "没有可填充的图层": "No fillable layer",
  "填充失败，请选中图片或可填充图层":
    "Fill failed. Select an image or fillable layer",
  "请在图片上点击以操作": "Click on the image to proceed",
  "无法读取图片像素，请检查图片是否跨域":
    "Cannot read image pixels. Check whether the image is cross-origin",
  "未找到可擦除区域，请调高容差": "No erasable area found. Increase tolerance",
  "未找到足够大的相似区域，请调高容差":
    "No large enough similar area found. Increase tolerance",
  "请先选中图层": "Select a layer first",
  "无法创建蒙版画布": "Cannot create mask canvas",
  "请先选中图片图层": "Select an image layer first",
  "选区尺寸无效，请重新框选": "Selection size is invalid. Select again",
  "选区蒙版创建失败": "Failed to create selection mask",

  // 属性 / 滤镜 / 蒙版
  "历史记录": "History",
  "暂无历史记录": "No history yet",
  "{0} 层": "{0} layers",
  "选中图层后在属性面板编辑": "Select a layer to edit in the properties panel",
  "修改属性": "Edit properties",
  "类型：{0}": "Type: {0}",
  "图层 ID": "Layer ID",
  "外观": "Appearance",
  "图层效果": "Layer effects",
  "字号": "Font size",
  "对齐": "Align",
  "行距": "Line height",
  "中": "Center",
  "左": "Left",
  "右": "Right",
  "上": "Top",
  "下": "Bottom",
  "混合模式": "Blend mode",
  "正常": "Normal",
  "正片叠底": "Multiply",
  "滤色": "Screen",
  "叠加": "Overlay",
  "变暗": "Darken",
  "变亮": "Lighten",
  "颜色减淡": "Color dodge",
  "颜色加深": "Color burn",
  "强光": "Hard light",
  "柔光": "Soft light",
  "差值": "Difference",
  "排除": "Exclusion",
  "填充": "Fill",
  "描边色": "Stroke color",
  "描边宽": "Stroke width",
  "等比缩放": "Constrain proportions",
  "锚点 X": "Anchor X",
  "锚点 Y": "Anchor Y",
  "投影": "Drop shadow",
  "外发光": "Outer glow",
  "X 偏移": "Offset X",
  "Y 偏移": "Offset Y",
  "清除图层效果": "Clear layer effects",
  "修改图片": "Edit image",
  "替换图片": "Replace image",
  "二维码内容": "QR code content",
  "条形码内容": "Barcode content",
  "修改画布尺寸": "Change canvas size",
  "滤镜": "Filters",
  "类型": "Type",
  "亮度": "Brightness",
  "对比度": "Contrast",
  "饱和度": "Saturation",
  "模糊": "Blur",
  "原图": "Original",
  "强度": "Intensity",
  "模糊强度": "Blur amount",
  "应用滤镜": "Apply filter",
  "选中图片图层后可调整滤镜、裁剪与蒙版":
    "Select an image layer to adjust filters, crop, and masks",
  "码图不支持滤镜与裁剪": "Code images do not support filters or crop",
  "比例裁剪": "Aspect crop",
  "画布裁剪框": "Canvas crop box",
  "在画布上拖拽调整裁剪区域 · Enter 确认 · Esc 取消":
    "Drag on the canvas to adjust the crop · Enter to apply · Esc to cancel",
  "进入裁剪模式": "Enter crop mode",
  "确认": "Confirm",
  "自由裁剪（边距 %）": "Free crop (margin %)",
  "对标 PS 裁剪工具 — 按四边向内裁切显示区域":
    "Photoshop-style crop — inset from each edge",
  "应用自由裁剪": "Apply free crop",
  "清除": "Clear",
  "选中图层后可添加矢量蒙版、位图蒙版或剪贴蒙版":
    "Select a layer to add a vector, bitmap, or clipping mask",
  "剪贴蒙版": "Clipping mask",
  "位图蒙版": "Bitmap mask",
  "形状蒙版（{0}）": "Shape mask ({0})",
  "矢量": "Vector",
  "自由裁剪蒙版": "Free crop mask",
  "已启用蒙版": "Mask enabled",
  "矢量蒙版": "Vector mask",
  "当前：": "Current: ",
  "用紧邻下层图层的形状裁剪当前图层":
    "Clip the current layer using the shape of the layer immediately below",
  "剪贴蒙版：Alt+点击下层图层，或 Ctrl+Alt+G（内容层须在蒙版层之上）。":
    "Clipping mask: Alt-click the layer below, or Ctrl+Alt+G (content must be above the mask).",
  "位图蒙版笔刷": "Bitmap mask brush",
  "开始涂抹": "Start painting",
  "结束涂抹": "Stop painting",
  "硬度 100% 为硬边笔刷，0% 为全羽化软边；涂抹中可实时调整大小与硬度。":
    "Hardness 100% is a hard brush, 0% is fully soft; size and hardness can change while painting.",
  "{0}px · 硬度 {1}%": "{0}px · hardness {1}%",
  "隐藏": "Hide",
  "靠左对齐": "Align left",
  "靠右对齐": "Align right",
  "靠上对齐": "Align top",
  "靠下对齐": "Align bottom",
  "上移": "Move up",
  "下移": "Move down",
  "置顶": "Bring to front",
  "置底": "Send to back",
  "圆形蒙版": "Ellipse mask",
  "图层管理": "Layer order",

  // 胶片条 / 颜色主图
  "选颜色": "Pick color",
  "颜色选项": "Color options",
  "颜色：{0}": "Color: {0}",
  "选择颜色": "Select color",
  "选择主图颜色": "Select main-image color",
  "从颜色库选择颜色": "Pick a color from the color library",
  "颜色库暂无颜色，请先在 SHEIN 官方产品模板中配置颜色":
    "No colors in the library yet. Configure colors in the SHEIN official product template first.",
  "主图颜色": "Main-image color",
  "收起颜色选项": "Collapse color options",
  "展开颜色选项": "Expand color options",
  "已跳过 {0} 张不支持的格式": "Skipped {0} unsupported file(s)",
  "图片「{0}」处理失败，已跳过": "Failed to process image “{0}”; skipped",
  "添加页面": "Add page",
  "添加细节图": "Add detail image",
  "确认删除": "Confirm delete",
  "确定删除「{0}」？该页上的印花与图层将一并移除。":
    "Delete “{0}”? Print areas and layers on this page will also be removed.",
  "复制此页": "Duplicate page",
  "删除此页": "Delete page",
  "编辑名称": "Edit name",
  "编辑页面名称": "Edit page name",
  "页面名称": "Page name",
  "添加颜色主图": "Add color main image",
  "图片预览": "Image preview",
  "关闭": "Close",
  "添加中…": "Adding…",
  "确认添加": "Confirm add",
  "张主图": "main images",
  "请先在「商品主图」中添加并选择主图":
    "Add and select a main image under “Main images” first",

  // plugin 历史 / 右键
  "初始状态": "Initial state",
  "移动图层": "Move layer",
  "画笔绘制": "Brush stroke",
  "选区填充": "Fill selection",
  "添加二维码": "Add QR code",
  "添加条形码": "Add barcode",
  "绘制多边形": "Draw polygon",
  "蒙版画笔": "Mask brush",
  "套索绘制": "Lasso draw",
  "图层上移": "Bring layer forward",
  "图层下移": "Send layer backward",
  "图层置顶": "Bring layer to front",
  "图层置底": "Send layer to back",
  "调整图层顺序": "Reorder layers",
  "新建组": "New group",
  "移入分组": "Move into group",
  "移出分组": "Move out of group",
  "选区蒙版置顶": "Selection mask on top",
  "选区蒙版置底": "Selection mask at bottom",
  "应用蒙版": "Apply mask",
  "自由裁剪": "Free crop",
  "组 {0}": "Group {0}",
  "导入 IPE 模板": "Import IPE template",
  "导入 IPE 模板失败": "Failed to import IPE template",
  "导入 IPE 失败": "IPE import failed",
  "应用文字样式": "Apply text style",
  "此处无法取色": "Cannot sample color here",
  "选区过小": "Selection is too small",
  "请点击图片图层或先创建选区": "Click an image layer or create a selection first",
  "填充失败（可能跨域图片无法取样）":
    "Fill failed (the image may be cross-origin and cannot be sampled)",

  // 左栏：模板 / 素材 / 字体 / 我的 / 元素
  "全部": "All",
  "通用": "General",
  "海报": "Poster",
  "长图": "Long image",
  "模板分类": "Template category",
  "素材分类": "Material category",
  "字体样式分类": "Font style category",
  "在{0}中搜索": "Search in {0}",
  "暂无匹配模板": "No matching templates",
  "暂无匹配素材": "No matching materials",
  "暂无匹配样式": "No matching styles",
  "已经到底了": "End of list",
  "提示": "Notice",
  "确定": "Confirm",
  "载入「{0}」将替换当前画布内容，是否继续？":
    "Loading “{0}” will replace the current canvas. Continue?",
  "角标": "Corner badge",
  "标签": "Label",
  "装饰": "Decorative",
  "标题": "Title",
  "副标题": "Subtitle",
  "已应用到选中文字": "Applied to selected text",
  "已添加到画布": "Added to canvas",
  "搜索当前页名称": "Search names on this page",
  "搜索当前页图片名称": "Search image names on this page",
  "上传到图片空间": "Upload to image library",
  "已上传 {0} 张到图片空间": "Uploaded {0} image(s) to the image library",
  "上传失败，请重试": "Upload failed. Please try again.",
  "加载图片空间…": "Loading image library…",
  "当前页未找到匹配的图片": "No matching images on this page",
  "图片空间暂无图片，请上传": "No images in the library yet. Upload some.",
  "条记录": "records",
  "图片空间分页": "Image library pagination",
  "画布左侧为 PS 风格工具条；此处提供完整元素库与码图。":
    "The left toolbar is Photoshop-style; this panel offers the full element library and codes.",
  "文字与形状": "Type & shapes",
  "文字 (T)": "Type (T)",
  "矩形 (U)": "Rectangle (U)",
  "绘制": "Draw",
  "画笔 (B)": "Brush (B)",
  "码图": "Codes",
  "二维码": "QR code",
  "条形码": "Barcode",
  "V 移动 · T 文字 · U 矩形 · B 画笔 · 空格拖动画布 · Ctrl+Z 撤销":
    "V Move · T Type · U Rectangle · B Brush · Space pan canvas · Ctrl+Z Undo",

  // hooks / toast / 蒙版 tip / 默认文字
  "画布尚未就绪，请稍候": "Canvas is not ready yet. Please wait.",
  "已添加 {0} 张图片": "Added {0} image(s)",
  "图片上传失败": "Image upload failed",
  "一切安好": "All good",
  "一切顺利": "All set",
  "请输入图片名称": "Enter an image name",
  "图片名称已更新": "Image name updated",
  "正在强制覆盖保存…": "Force overwriting…",
  "正在准备…": "Preparing…",
  "已保存 {0} 张套图": "Saved {0} set image(s)",
  "保存失败": "Save failed",
  "导出 IPE 失败": "Failed to export IPE",
  "读取文件失败": "Failed to read file",
  "图层蒙版": "Layer mask",
  "蒙版：仅显示白色区域": "Mask: only white areas are visible",
  "蒙版：黑色区域已隐藏": "Mask: black areas are hidden",
  "单击放置锚点；点起点或 Enter 闭合并生成选区（可用添加/减去）":
    "Click to place anchors; click the start point or press Enter to close and create a selection (add/subtract supported)",

  // 保存进度 / 校验 / 默认页名 / 图层默认名
  "正在准备画布…": "Preparing canvas…",
  "正在上传预览图…": "Uploading preview…",
  "正在保存 {0} 页画布…": "Saving {0} canvas page(s)…",
  "正在提交模板…": "Committing template…",
  "保存完成": "Save complete",
  "画布预览": "Canvas preview",
  "默认": "Default",
  "模板主图与颜色配置不完整": "Main images and color setup are incomplete",
  "模板图片上传失败，请检查网络后重试":
    "Failed to upload template image. Check the network and try again.",
  "模板图片「{0}」上传失败，请更换该图或检查网络后重试":
    "Failed to upload template image “{0}”. Replace it or check the network and try again.",
  "模板已被其他会话修改，请刷新后重试":
    "This template was modified in another session. Refresh and try again.",
  "保存模板失败，请重试": "Failed to save template. Please try again.",
  "请至少添加一张主图": "Add at least one main image",
  "请至少保留一张主图": "Keep at least one main image",
  "颜色不能重复：{0}{1}": "Duplicate colors: {0}{1}",
  "主图数量与颜色数量不一致，请为每张主图选择唯一颜色":
    "Main image count does not match color count. Pick a unique color for each main image.",
  "存在未关联主图的细节图，请删除或重新关联":
    "Some detail images are not linked to a main image. Delete or relink them.",
  "主图{0}": "Main {0}",
  "细节图{0}": "Detail {0}",
  "未命名主图": "Untitled main image",
  "未命名细节图": "Untitled detail image",
  "已保存并重新合成": "Saved and recomposed",
  "套索": "Lasso",
  "多边形套索": "Polygonal lasso",
};
